import React, {ReactNode, ComponentPropsWithoutRef} from 'react';
import classNames from 'classnames';
import styles from './unstyled-button.module.scss';

interface Props extends ComponentPropsWithoutRef<'button'> {
  className?: string;
  children: ReactNode;
  testId?: string;
}

const UnstyledButton = ({className, children, testId, ...buttonProps}: Props) => (
  <button className={classNames(styles.button, className)} data-testid={testId} {...buttonProps}>
    {children}
  </button>
);

export default UnstyledButton;
